/* global console */
/**
 * Log de debug gateado por build: silencioso em produção (`__DEBUG__` = false),
 * verboso em dev. Evita vazar conteúdo do documento no console do WebView em
 * produção. `console.warn`/`console.error` permanecem sempre ativos — erros
 * importam em qualquer ambiente.
 */
export function dlog(...args) {
    if (__DEBUG__)
        console.log(...args);
}
